




































































import { Vue, Component, Prop } from "vue-property-decorator";
import Api from "../../api/index";
import Mine from "./mine/index.vue";
import ToSend from "./tosend/index.vue";
import Send from "./send/index.vue";
import Todos from "./todos/index.vue";
import LsSelectUser from "./LsSelectUser/LsSelectUserPage.vue";
import LsSelectOrg from "./LsSelectOrg/SelectIndex.vue";
import LsSelectDict from "./LsSelectDict/LsSelectDictPage.vue";
import Dones from "./dones/index.vue";
import Finishs from "./finish/index.vue";
import Term from "./term/index.vue";
import Copy from "./copy/index.vue";
import TodoAll from "./todoAll/index.vue";
import DoneAll from "./doneAll/index.vue";
import request from "@/package/api/request";
import { getCookie } from "@szgc/plt-core-v2";

import SzgcMobileGetor from "../../../../mobile/package/SzgcMobileGetor/index.vue";
import SzgcProcessGetor from "../../../../pt/package/SzgcProcessGetor/index.vue";

Vue.component("SzgcMobileGetor", SzgcMobileGetor);
Vue.component("SzgcProcessGetor", SzgcProcessGetor);

@Component({
  name: "SzgcWbench",
  components: {
    Mine,
    ToSend,
    Send,
    Todos,
    LsSelectUser,
    LsSelectOrg,
    LsSelectDict,
    Dones,
    Finishs,
    Term,
    Copy,
    TodoAll,
    DoneAll
  }
})
export default class SzgcWbench extends Vue {
  @Prop({
    type: String,
    default: "web"
  })
  private client!: string;

  @Prop({
    type: Number,
    default: 0
  })
  private tab!: number;

  @Prop({
    type: Boolean,
    default: false
  })
  private topShow!: boolean;

  @Prop({
    type: String,
    default: ""
  })
  private hideTabs!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  private fileShow!: boolean;

  private nowTab: number = 0;
  private prefix: string = "";
  private activeName: string = "Mine";
  private pages: any = [];
  private btnList: any[] = [
    { label: "详细视图", class: "el-icon-s-grid" },
    { label: "简洁视图", class: "el-icon-menu" }
  ];

  async mounted() {
    this.nowTab = this.tab;
    this.prefix = getCookie("plt-api-route") || "";
    await this.handleTab();
    await this.getTotal();
  }

  /*处理展示的tab*/
  handleTab() {
    let temp: any = [],
      pages: any = [];
    if (this.nowTab === 0) {
      temp = [
        { label: "待办任务", name: "Todos", key: "todo", total: 0 },
        // { label: "人员选择测试", name: "LsSelectUser", key: "lsSelectUser" },
        // { label: "机构选择测试", name: "LsSelectOrg", key: "LsSelectOrg" },
        // { label: "字典选择测试", name: "LsSelectDict", key: "LsSelectDict" },
        { label: "已办任务", name: "Dones", key: "done" },
        { label: "待发事项", name: "ToSend", key: "wait", total: 0 },
        { label: "已发事项", name: "Send", key: "sent" },
        { label: "办结事项", name: "Finishs", key: "fine" },
        { label: "终止事项", name: "Term", key: "term" },
        { label: "抄送事项", name: "Copy", key: "cc" },
        { label: "我的模板", name: "Mine", key: "mine" }
      ];
    } else {
      temp = [
        { label: "待办", name: "TodoAll", key: "todo-all", total: 0 },
        { label: "已办", name: "DoneAll", key: "done-all" },
        { label: "抄送事项", name: "Copy", key: "cc" },
        { label: "我的模板", name: "Mine", key: "mine" }
      ];
    }
    temp.map((page: any) => {
      if (!(this.hideTabs.indexOf(page.key) > -1)) {
        pages.push(page);
      }
    });
    this.pages = pages;
    this.activeName = this.pages[0].name;
  }

  /*模式切换*/
  async typeChange(index: number) {
    this.nowTab = index;
    await this.handleTab();
    await this.getTotal();
  }

  /*mine页面抛出数据*/
  childEvt(data: any) {
    this.$emit("childEvt", { data: data.data.formData });
  }

  /*获取待办待发统计*/
  async getTotal() {
    try {
      const { success, message, data } = await request({
        url: this.prefix + Api.getListTotal,
        method: "get"
      });
      if (!success) {
        return this.$message.error("获取待办/待发条数失败:" + message);
      }
      if (this.nowTab === 0) {
        this.pages[0].total = data.todoNum > 99 ? 99 : data.todoNum;
        this.pages[2].total = data.waitNum > 99 ? 99 : data.waitNum;
      } else {
        if (data.todoNum + data.waitNum > 99) {
          this.pages[0].total = 99;
        } else {
          this.pages[0].total = data.todoNum + data.waitNum;
        }
      }
    } catch (error: any) {
      this.$message.error("获取待办/待发条数失败:" + error);
    }
  }
}
